import React, { useEffect, useState } from "react";
import styles from "./ConsultaForm.module.css";
import { DrawDatePicker } from "../../../../../components/ui";
import useResultDates from "../../../../../hooks/useResultDates";

/**
 * @param {object} props
 * @param {{ id: string, name: string }[]} props.lotteries
 * @param {object[]} [props.results]
 * @param {string} [props.initialLotteryId]
 * @param {string} [props.initialDate]
 * @param {(payload: { lotteryId: string, date: string, numero: string, serie: string }) => void} props.onConsultarNumero
 * @param {{ type: string, text: string }} props.consultMessage
 * @param {boolean} [props.searching]
 */
const ConsultaForm = ({
  lotteries = [],
  results = [],
  initialLotteryId = "",
  initialDate = "",
  onConsultarNumero,
  consultMessage,
  searching = false,
}) => {
  const [lotteryId, setLotteryId] = useState(initialLotteryId);
  const [date, setDate] = useState(initialDate);
  const [numero, setNumero] = useState("");
  const [serie, setSerie] = useState("");

  const { dates, loading: datesLoading } = useResultDates(lotteryId, lotteries, results);

  useEffect(() => {
    setLotteryId(initialLotteryId);
  }, [initialLotteryId]);

  useEffect(() => {
    setDate(initialDate);
  }, [initialDate]);

  useEffect(() => {
    if (datesLoading) return;
    if (date && dates.length > 0 && !dates.includes(date)) {
      setDate("");
    }
  }, [date, dates, datesLoading]);

  const handleNumero = (e) => {
    e.preventDefault();
    onConsultarNumero?.({ lotteryId, date, numero, serie });
  };

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.title}>¡Consulta si tu número es el ganador!</h2>
      <p className={styles.subtitle}>
        Elige una fecha de sorteo. Puedes dejar la lotería en Todas o filtrar por número.
      </p>

      {consultMessage?.text && (
        <div
          className={
            consultMessage.type === "success" ? styles.bannerSuccess : styles.bannerError
          }
          role="status"
        >
          {consultMessage.text}
        </div>
      )}

      <form className={styles.form} onSubmit={handleNumero}>
        <label className={styles.selectLabel}>
          <span className={styles.fieldLabel}>Lotería</span>
          <select
            value={lotteryId}
            onChange={(e) => setLotteryId(e.target.value)}
            className={styles.select}
          >
            <option value="">Todas</option>
            {lotteries.map((l) => (
              <option key={l.id} value={l.id}>
                {l.name}
              </option>
            ))}
          </select>
        </label>

        <div className={styles.selectLabel}>
          <span className={styles.fieldLabel}>Fecha del sorteo</span>
          <DrawDatePicker
            dates={dates}
            value={date}
            onChange={setDate}
            placeholder="Seleccionar fecha"
          />
        </div>

        <div className={styles.inputsRow}>
          <div className={styles.inputGroup}>
            <label className={styles.label}>Número</label>
            <input
              className={styles.input}
              placeholder="Ej: 0001"
              value={numero}
              onChange={(e) => setNumero(e.target.value.replace(/\D/g, "").slice(0, 4))}
              inputMode="numeric"
              maxLength={4}
            />
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.label}>Serie</label>
            <input
              className={styles.input}
              placeholder="Ej: 001"
              value={serie}
              onChange={(e) => setSerie(e.target.value.replace(/\D/g, "").slice(0, 3))}
              inputMode="numeric"
              maxLength={3}
            />
          </div>
        </div>

        <div className={styles.actions}>
          <button
            type="submit"
            className={styles.primary}
            disabled={searching}
            aria-busy={searching}
          >
            {searching ? "Buscando…" : "Buscar"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default ConsultaForm;
